// export UploadDesignImg from "./uploadDesignImg";

export const UploadDesignImg=dsf.defineLazyComponent("DsfUploadDesignImg", () => require("./uploadDesignImg.vue"));